import React, { useEffect, useState } from "react";
import { Snackbar, Switch } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useHistory } from "react-router-dom";

import "./Career.css";
import { api_call } from "../../utils/Network";
import Title from "../../assets/dragonfly.png";
import Dgirl from "../../assets/dragongirl.png";
import Circle from "../../assets/grps.png";

const countries = {
  ["Andhra Pradesh"]: [
    "Amaravati",
    "Visakhapatnam",
    "Vijayawada",
    "Guntur",
    "Nellore",
    "Tirupati",
  ],
  ["Arunachal Pradesh"]: [
    "Itanagar",
    "Tawang",
    "Bhismaknagar",
    "Pasighat",
    "Ziro",
    "Bomdila",
  ],
  Assam: [
    "	Dispur",
    "Guwahati",
    "Tezpur",
    "Dibrugarh",
    "Silchar",
    "North Lakhimpur",
  ],
  Bihar: ["Patna", "Gaya", "Biharsharif", "Darbhanga", "Bhagalpur"],
  Chhattisgarh: [
    "Raipur",
    "Bilaspur",
    "Korba",
    "Durg-Bhilainagar",
    "Raigarh",
    "Rajnandgaon",
  ],
  Goa: ["Panaji", "Vasco-da-Gama", "Ponda", "Margao", "Mapusa", "Goa Velha"],
  Gujarat: [
    "Gandhinagar",
    "Ahmedabad",
    "Surat",
    "Rajkot",
    "Junagadh",
    "Vadodara",
  ],
  Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad", "Solapur"],
  ["Madhya Pradesh"]: [
    "Bhopal",
    "Indore",
    "Gwalior",
    "Jabalpur",
    "Ujjain",
    "Sagar",
  ],
  Rajasthan: ["	Jaipur", "Bikaner", "Jaisalmer", "Jodhpur", "Udaipur", "Ajmer"],
};

const countryList = Object.keys(countries).map((key) => ({
  name: key,
}));

function Career() {
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [msg, setMsg] = useState("");
  const [updateCode, setCodes] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [errors, setErrors] = useState({ name: "" });
  const [values, setValues] = useState({ names: "" });
  const [updatePhone, setPhoneNumber] = useState("");
  const [userData, setUserData] = useState({
    f_name: "",
    l_name: "",
    address: "",
    pincode: "",
    phone: "",
    code: "",
    isd: "+91",
    vacc1: 1,
    vacc2: 1,
  });
  const history = useHistory();
  var temp = {};

  useEffect(() => window.scrollTo(0, 0), []);

  function handleCountrySelect(e) {
    const countrySel = e.target.value;
    const { name } = e.target;
    const citiesSel = countrySel !== "" ? countries[countrySel] : "";
    setSelectedState(countrySel);
    setCities(citiesSel);
    setSelectedCity("");
    setErrors({ ...errors, [name]: "" });
  }

  function handleCitySelect(e) {
    const citiesSel = e.target.value;
    const { name } = e.target;
    setSelectedCity(citiesSel);
    setErrors({ ...errors, [name]: "" });
  }

  const handle = (event) => {
    const { name, value } = event.target;
    setUserData({ ...userData, [name]: value });
    setErrors({ ...errors, [name]: "" });
    setValues({ ...values, [name]: "" });
  };

  const validate = () => {
    let nameTest = /^[a-zA-Z ]{2,30}$/;
    let returnValue = true;
    temp.f_name = nameTest.test(userData.f_name)
      ? ""
      : "Please enter valid name.";
    temp.l_name = nameTest.test(userData.l_name)
      ? ""
      : "Please enter valid last name";
    temp.phone =
      (userData.phone === "")
        ? "Please enter phone number"
        : updatePhone !== ""
        ? ""
        : "Please verify phone number";
    temp.address = userData.address !== "" ? "" : "Please add your Address";
    temp.pincode = /^(\d{4}|\d{6})$/.test(userData.pincode)
      ? ""
      : "Please Enter valid pincode";
    temp.State = selectedState !== "" ? "" : "Please Select State";
    temp.Cities = selectedCity !== "" ? "" : "Please Select City";
    setErrors({
      ...temp,
    });
    var found = Object.keys(temp).filter(function (key) {
      return temp[key].includes("Please");
    });
    if (found.length) {
      // console.log(temp);
      returnValue = false;
    }
    return returnValue;
  };

  const GetOtp = () => {
    const data = {
      isd: "+91",
      phone: userData.phone,
    };
    if(/^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/.test(userData.phone)){
      api_call
      .post("/service_list/dragonfly/send_otp/", data)
      .then((response) => {
        const { statusText, data } = response;
        if (statusText === "Bad Request") {
          setErrors({ phone: "Please Enter Valid Phone number" });
        } else {
          setErrors({ phone: "" });
          setValues({ phone: "OTP Sent Successfully" });
        }
      })
      .catch((error) => setErrors());
      
    }else{
      setErrors({phone: "Please enter valid phone number"})
    }

  };

  const Verify = () => {
    const data = {
      isd: "+91",
      phone: userData.phone,
      code: userData.code,
    };
    api_call
      .post("/service_list/dragonfly/verify_otp/", data)
      .then((response) => {
        const { status, data } = response;
        if (status !== 200) {
          setErrors({ code: data.code[0] });
        } else if (status == 200) {
          setValues({ code: "Phone number Verified" });
          setPhoneNumber(userData.phone);
          setCodes(userData.code);
        }
      })
      .catch((error) => {
        setErrors();
      });
  };

  const SubmitData = () => {
    if (!validate()) return null;
    var payload = {
      first_name: userData.f_name,
      last_name: userData.l_name,
      isd: userData.isd,
      phone: updatePhone,
      address1: userData.address,
      city: selectedCity,
      state: selectedState,
      pincode: userData.pincode,
      vaccine_status1: userData.vacc1,
      vaccine_status2: userData.vacc2,
      code: updateCode,
    };
    api_call
      .post("service_list/dragonfly/register/", payload)
      .then((response) => {
        setMsg("Applied Successfully");
        setTimeout(() => history.push("/"), 1000);
      })
      .catch((error) => console.log(error));
  };

  return (
    <>
      <div className="careerHeader cart-main">
        <div className="cart-contents">
          

          <div
            className="crt_grl"
            style={{ padding: "20px 20px 0", overflow: "hidden" }}
          >
            <img src={Dgirl} alt="title" className="title_girl"></img>
            <img src={Circle} alt="title" className="gold-circle"></img>
          </div>
          <div style={{ margin: "30px 0" }}>
            <h1 className="crt_head">Join The GRF Family</h1>
          </div>
          <div className=" crt_grl crt_grls">
            <img src={Title} alt="title" className="title_img"></img>
          </div>
        </div>
      </div>
      <div className="cart_content">
        <div className="cart-main carrer_datas">
          <div className="cr_">
            <h2 className="cr_title">Enter Details To Apply</h2>
          </div>
          <div className="cr_wrap">
            <div className="f_inputs">
              <input
                placeholder="First Name"
                className="cr_input cr_ip_name"
                name="f_name"
                onChange={handle}
              ></input>
              <p className="errors">{errors !== undefined && errors.f_name}</p>
            </div>
            <div className="f_inputs">
              <input
                placeholder="Last Name"
                className="cr_input cr_ip_name"
                name="l_name"
                onChange={handle}
              ></input>
              <p className="errors">{errors !== undefined && errors.l_name}</p>
            </div>
          </div>
          <div className="cr_wrap cr_wrap_mobile">
            <div
              className="f_inputs f_inputs_mobile"
              style={{ position: "relative" }}
            >
              <div className="cr_input" style={{ padding: "8px 6px" }}>
                <span className="login-isd">+91</span>
                <input
                  placeholder="Phone Number"
                  className="inp_number"
                  name="phone"
                  onChange={handle}
                  maxLength="10"
                ></input>
                <button className="btn_otp btn_green" onClick={GetOtp}>
                  Get OTP
                </button>
              </div>
              <p className="errors">{errors !== undefined && errors.phone}</p>
              <p style={{ color: "green" }}>{values.phone}</p>
            </div>
            <div
              className="f_inputs f_inputs_mobile"
              style={{ position: "relative" }}
            >
              <input
                placeholder="Enter OTP"
                className="cr_input"
                name="code"
                onChange={handle}
                type="number"
              ></input>
              <button className="btn_otp btn_green" onClick={Verify}>
                Verify
              </button>
              <p className="errors">{errors !== undefined && errors.code}</p>
              <p style={{ color: "green" }}>{values.code}</p>
            </div>
          </div>
          <div className="cr_wrap">
            <div className="f_inputs f_inp_add">
              <input
                placeholder="Address"
                className="cr_input cr_addr"
                name="address"
                onChange={handle}
              ></input>
              <p className="errors">{errors !== undefined && errors.address}</p>
            </div>
          </div>
          <div className="cr_wrap cr_wrap_mobile crwm">
            <div className="sel_inputs">
              <select
                name="State"
                className="cr_select"
                onChange={(e) => handleCountrySelect(e)}
                value={selectedState}
              >
                <option value="">Select State</option>
                {countryList.length !== 0 &&
                  countryList.map((country, key) => (
                    <option key={key} value={country.name}>
                      {country.name}
                    </option>
                  ))}
              </select>
              <p className="errors">{errors !== undefined && errors.State}</p>
            </div>
            <div className="sel_inputs">
              <select
                className="cr_select"
                name="Cities"
                onChange={(e) => handleCitySelect(e)}
                value={selectedCity}
              >
                <option value="">Select city</option>
                {cities.length !== 0 &&
                  cities.map((city, key) => (
                    <option key={key} value={city}>
                      {city}
                    </option>
                  ))}
              </select>
              <p className="errors">{errors !== undefined && errors.Cities}</p>
            </div>
            <div className="sel_inputs">
              <input
                placeholder="Enter Pin Code"
                className="cr_input"
                style={{ margin: "0" }}
                name="pincode"
                onChange={handle}
              ></input>
              <p className="errors">{errors !== undefined && errors.pincode}</p>
            </div>
          </div>
          <div style={{ margin: "20px 40px" }}>
            <h2>Vacination Status</h2>
          </div>
          <div className="cr_wrap">
            <div
              className="f_inputs"
              style={{ display: "flex", alignItems: "center" }}
            >
              <p>Dose 1</p>
              <div>
                <Switch
                  checked={userData.vacc1 === 1}
                  onChange={() =>
                    setUserData({ ...userData, vacc1: userData.vacc1 ? 0 : 1 })
                  }
                  color="primary"
                />
              </div>
            </div>
            <div
              className="f_inputs"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>Dose 2</div>
              <div>
                <Switch
                  checked={userData.vacc2 === 1}
                  onChange={() =>
                    setUserData({ ...userData, vacc2: userData.vacc2 ? 0 : 1 })
                  }
                  color="primary"
                />
              </div>
            </div>
          </div>
          {/* <div style={{ margin: "20px 40px" }}>
            <div>
              <p>Upload Certificate</p>
            </div>
            <div>
              <input type="file"></input>
            </div>
          </div> */}
          <div style={{ margin: "20px 40px" }}>
            <p>Having Trouble ?</p>
            <div>
              {/* <button className="btn_cr btn_purple">Get A Call Back</button> */}
              <button className="btn_cr btn_green" onClick={SubmitData}>
                Apply Now
              </button>
            </div>
          </div>
        </div>
      </div>
      {msg && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={() => setMsg("")}
          autoHideDuration={3000}
          message={msg}
        >
          <Alert severity="success">{msg}</Alert>
        </Snackbar>
      )}
    </>
  );
}

export default Career;
